import { Box, Typography } from "@mui/material"
import { DataGrid } from '@mui/x-data-grid';

const columns = [
    { field: 'status', headerName: 'Hour', width: 130, align: "left"},
    { field: 'count_00', headerName: '0', width: 70, type: "number", align: "left", headerAlign: "left"},
    { field: 'count_01', headerName: '1', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_02', headerName: '2', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_03', headerName: '3', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_04', headerName: '4', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_05', headerName: '5', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_06', headerName: '6', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_07', headerName: '7', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_08', headerName: '8', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_09', headerName: '9', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_10', headerName: '10', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_11', headerName: '11', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_12', headerName: '12', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_13', headerName: '13', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_14', headerName: '14', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_15', headerName: '15', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_16', headerName: '16', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_17', headerName: '17', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_18', headerName: '18', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_19', headerName: '19', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_20', headerName: '20', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_21', headerName: '21', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_22', headerName: '22', width: 70, type: "number", align: "left", headerAlign: "left" },
    { field: 'count_23', headerName: '23', width: 70, type: "number", align: "left", headerAlign: "left" },
];

const rows = [
    {
        id: 1,
        status: "Transactions",
        count_00: 100,
        count_01: 150,
        count_02: 10,
        count_03: 234,
        count_04: 234,
        count_05: 100,
        count_06: 300,
        count_07: 345,
        count_09: 400,
        count_08: 300,
        count_10: 345,
        count_11: 356,
        count_12: 456,
        count_13: 350,
        count_14: 300,
        count_15: 200,
        count_16: 250,
        count_17: 150,
        count_18: 150,
        count_19: 230,
        count_20: 100,
        count_21: 115,
        count_22: 112,
        count_23: 156,
    },
    {
        id: 2,
        status: "Errors",
        count_00: 0,
        count_01: 0,
        count_02: 0,
        count_03: 5,
        count_04: 0,
        count_05: 0,
        count_06: 0,
        count_07: 0,
        count_09: 0,
        count_08: 0,
        count_10: 0,
        count_11: 0,
        count_12: 0,
        count_13: 0,
        count_14: 50,
        count_15: 0,
        count_16: 0,
        count_17: 0,
        count_18: 0,
        count_19: 0,
        count_20: 11,
        count_21: 0,
        count_22: 0,
        count_23: 0,
    }
  ];

export const UBRealTimeMock = () => {
    return (
        <Box
            container
            minHeight="95vh"
            height="100%"
            sx={{
                boxSizing: 'border-box',
                display: 'grid',
                gridTemplateColumns: 'repeat(8, 1fr)',
                gap: 1,
                p: 1,
            }}
        >
            {[{ category_label: "Enrollment", subcategories: ["Fast Track", "Call to Action"] }].map(category =>
                <>
                    <Box sx={{ gridColumn: "span 8" }}>
                        <Typography variant="h4" fontWeight="bold" align="center">{category.category_label}</Typography>
                    </Box>

                    {category.subcategories.map(subcategory => 
                        <Box sx={{ gridColumn: "span 8" }}>
                            <Typography variant="h5" fontWeight="bold" gutterBottom align="left">{subcategory}</Typography>

                            <DataGrid
                                title="test"
                                rows={rows}
                                columns={columns}
                                hideFooter
                                autoHeight
                            />
                        </Box>
                    )}
                </>
            )}
        </Box>
    );
}